const CUSTOM_MCP_MAX_HEADERS = 20;
const RESERVED_HEADERS = new Set([
  'authorization', 'host', 'content-length', 'connection', 'transfer-encoding',
  'accept', 'accept-encoding', 'content-type', 'keep-alive', 'te', 'trailer',
  'upgrade', 'expect', 'origin', 'referer', 'cookie', 'set-cookie',
  'mcp-session-id', 'mcp-protocol-version', 'last-event-id',
]);

// Shared by the form and backend. Never include user-supplied values in errors.
const normalizeCustomHeaders = (headerList = []) => {
  if (!Array.isArray(headerList) || headerList.length > CUSTOM_MCP_MAX_HEADERS) {
    throw new Error('CUSTOM_MCP_HEADERS_LIMIT');
  }
  const entries = [];
  const names = new Set();
  let size = 0;
  for (const header of headerList) {
    if (!header || typeof header.name !== 'string' || typeof header.value !== 'string') {
      throw new Error('CUSTOM_MCP_HEADERS_INVALID');
    }
    const name = header.name.trim().toLowerCase();
    const value = header.value.trim();
    if (!name && !value) continue;
    if (!/^[a-z0-9-]{1,100}$/.test(name) || !value
      || /[^\x20-\x7e\x80-\xff]/.test(header.value) || value.length > 8192) {
      throw new Error('CUSTOM_MCP_HEADERS_INVALID');
    }
    if (RESERVED_HEADERS.has(name) || /^(proxy-|sec-|mcp-)/.test(name)) {
      throw new Error('CUSTOM_MCP_HEADERS_RESERVED');
    }
    if (names.has(name)) throw new Error('CUSTOM_MCP_HEADERS_DUPLICATE');
    names.add(name);
    size += name.length + value.length;
    if (size > 16384) throw new Error('CUSTOM_MCP_HEADERS_LIMIT');
    entries.push([name, value]);
  }
  return Object.fromEntries(entries);
};

module.exports = { CUSTOM_MCP_MAX_HEADERS, normalizeCustomHeaders };
